import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ChoosePassword = lazy(() => import("@/pages/auth/ChoosePassword"));

export const Route = createFileRoute("/valj-losenord")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Välj lösenord | Elmarknad.se" },
      { name: "description", content: "Aktivera ditt administratörskonto på Elmarknad.se genom att välja ett lösenord." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Välj lösenord | Elmarknad.se" },
      { property: "og:description", content: "Aktivera ditt administratörskonto på Elmarknad.se." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <ChoosePassword />,
});
